// extracted by mini-css-extract-plugin
module.exports = {"content":"K5h-Hd","info-checkbox":"_2BUdEt","info-title":"_2MIjET","info-content":"_3rV1O8","image-container":"_178tk6","image":"_3uN9Cw","link":"_3oiQ8l"};